/* eslint-disable */
import React, {ReactElement, useEffect, useState} from "react";
import {GET_USER_FROM_ACCESS_TOKEN} from "../../graphql/mutations/mutations";
import {SurveyData} from "../../models/survey";
import {QueryFunction} from "../../graphql/types";
import styles from "./signed-in.module.scss";
import {useMutation} from "@apollo/client";
import {PulseButton} from "../pulse-button";

import {useLocation, useNavigate} from "react-router-dom";
import {useAuthentication} from "../../hooks/user/useAuthentication";

export interface SignedInProps {
	surveyId?: string;
	/**
	 * Trigger refetch on logging out
	 */
	onLogout?: QueryFunction<SurveyData>;

	accessLevel?: string;
}

const SignedIn = (props: SignedInProps): ReactElement | null => {
	const navigate = useNavigate();
	const location = useLocation();
	const {user, logout, isAuthenticated, isAnonymousUser, email} = useAuthentication();
	const [isNavigating, setIsNavigating] = useState<boolean>(false);
	const [getUserFromAccessToken] = useMutation(GET_USER_FROM_ACCESS_TOKEN);
	const {surveyId, accessLevel} = props;

	/**
	 * Logs the user out before navigating to the auth page
	 */
	const handleLogout = (): void => {
		/**
		 * Calling logout and then logoutLegacy only works in this order with
		 * how the page reloads with the survey id in the url.
		 * Tried calling the way I did in the manager app within
		 * the onCompleted callback but no luck.
		 */
		logout();
	};

	const navigateToLogin = async (): Promise<void> => {
		if (isNavigating) return;
		setIsNavigating(true);
		try {
			await logout();
		} finally {
			if (surveyId) {
				localStorage.setItem("surveyId", surveyId);
			}
			navigate(`/login${location.search}`);
			setIsNavigating(false);
		}
	};

	useEffect(() => {
		if (!user) return;

		const token = user?.stsTokenManager?.accessToken;

		if (token && !isAnonymousUser) {
			try {
				getUserFromAccessToken({
					variables: {
						accessToken: token,
						name: user?.displayName,
					},
					onError: error => {
						console.error(error);
					},
				});
			} catch (e) {
				// eslint-disable-next-line no-console
				console.error(e);
			}
		}
	}, []);

	if (isAuthenticated && email) {
		return (
			<div className={styles.container}>
				<p className={styles.user}>
					Signed in as {email}{" "}
					<span onClick={handleLogout} className={styles.logout}>
						Sign out
					</span>
				</p>
			</div>
		);
	}
	// Check second in case user started off signed in.
	if (accessLevel?.toLocaleLowerCase() === "anonymous") return null;
	return (
		<div>
			<PulseButton
				text={isAnonymousUser ? "Sign in to answer" : "Sign in"}
				clicked={navigateToLogin}
				isDisabled={isNavigating}
			/>
		</div>
	);
};

export {SignedIn};
